// removed by extract-text-webpack-plugin
module.exports = {"tabs":"YqtQW-tabs","tabs--d-none":"_2-CD8-tabs--d-none","icon":"_2o7-o-icon","default":"_3CZI_-default","with-header":"_1Wsrh-with-header","card":"_3Zq10-card","phone":"_3G_EQ-phone","wallet":"_1cqeh-wallet","active":"_1h2de-active","material":"_2ee74-material","ios":"_3juwv-ios","react-tabs__tab-panel":"_11fHq-react-tabs__tab-panel","react-tabs__tab-panel--selected":"_1U-it-react-tabs__tab-panel--selected"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/TabsContainer/TabsContainer.scss
// module id = 760
// module chunks = 0